import Swiper, {Navigation, Autoplay, EffectFade} from 'swiper';

Swiper.use([Navigation, Autoplay, EffectFade]);

export default {
  blockSlider: () => {
    new Swiper('.block-slider', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slideClass: 'cmeleon-block-content',
    });
  },

  productTextMediaSlider: () => {
    new Swiper('.product-text-media', {
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 3000,
      },
    });
  },

  referenceSlider: () => {
    new Swiper('.swiper-reference', {
      slidesPerView: 8,
      loop: true,
      slideClass: 'cmeleon-block-content',
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  },

  newsSlider: () => {
    new Swiper('.news-slider', {
      slidesPerView: 1,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      }
    });
  },

  swiperMode: () => {
    const breakpoint = window.matchMedia('(min-width: 769px)');

    // uviscan
    const uviscanSubmenu = document.querySelector('.uviscan-submenu');
    if (uviscanSubmenu) {
      var myUviSwiper = void 0;

      const uviBreakpointChecker = function() {
        if (breakpoint.matches === true) {
          enableUviSwiper();
          myUviSwiper.destroy(true, true);
          return;
        } else {
          return enableUviSwiper();
        }
      };

      const enableUviSwiper = function() {
        myUviSwiper = new Swiper(uviscanSubmenu, {
          slidesPerView: 'auto',
          freeMode: true,
        });
      };

      breakpoint.addListener(uviBreakpointChecker);
      uviBreakpointChecker();
    }
  }
}
